<template>
  <div id="app-editor">
    <transition mode="out-in">
        <component :is="element" v-if="element" :editor="$options.editor" :opts="$options.opts" :payload="$options.payload" />
    </transition>
  </div>
</template>

<script>
// Load layout components dynamically.
const requireContext = require.context("./editor", false, /.*\.vue$/);
const elements = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});
export default {
    element:"default",

    data: () => ({
        element: null,
        defaultElement: "default"
    }),

    mounted() {
    /* this.$loading = this.$refs.loading; */
        this.setElement(this.$options.element);
    },

    methods: {
        /**
         * Set the application element.
         *
         * @param {String} element
         */
        setElement(element) {
            if (!element || !elements[element]) {
                element = this.defaultLayout;
            }
            this.element = elements[element];
        }
    }
};
</script>

<style>

</style>
